<template>
  <CreateUpdateTemplate
    :routePreventDialog="routePreventDialog"
    :hasChanges="hasChanges"
    :customClass="'create-contract create-form'"
    v-if="getPermission('contract:create') || getPermission('contract:update')"
  >
    <template v-slot:header-title>
      <div class="d-flex justify-space-between">
        <v-tooltip top content-class="custom-top-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <h1
              v-bind="attrs"
              v-on="on"
              class="form-title text-truncate d-flex align-baseline select-custom-data"
            >
              Contract for
              <div
                v-if="reEntityId"
                class="ml-3 form-title-link cursor-pointer text-h5"
                v-on:click="openEntityDialog()"
              >
                {{ reEntity.name }}
              </div>
              <template v-else>
                <div
                  class="ml-3 form-title-link cursor-pointer text-h5"
                  v-on:click="openEntityDialog()"
                >
                  Select a Entity
                  <v-icon large color="cyan">mdi-home-edit</v-icon>
                </div>
              </template>
            </h1>
          </template>
          <span>Entity</span>
        </v-tooltip>

        <v-spacer></v-spacer>
        <v-chip
          label
          color="chip-custom-blue"
          outlined
          class="text-white p-3 mr-4"
          style="font-size: 21px !important; font-weight: 700"
        >
          <template>
            {{ dbContract.barcode }}
          </template>
        </v-chip>
      </div>
      <div class="d-flex justify-space-between mt-2">
        <v-tooltip bottom content-class="custom-bottom-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <h1
              v-bind="attrs"
              v-on="on"
              class="form-title text-truncate d-flex align-baseline select-custom-data"
            >
              Contract for
              <div
                v-if="vCustomerId"
                class="ml-3 form-title-link cursor-pointer text-h5"
                v-on:click="openDialog('customer')"
              >
                {{ vCustomer.display_name }}
              </div>
              <template v-else>
                <div
                  class="ml-3 form-title-link cursor-pointer text-h5"
                  v-on:click="openDialog('customer')"
                >
                  Select a Customer
                  <v-icon large color="cyan">mdi-account-check-outline</v-icon>
                </div>
                <div class="mx-3">OR</div>
                <div
                  class="form-title-link cursor-pointer cyan--text text--darken-4 text-h5"
                  v-on:click="createCustomerDialog()"
                >
                  Create a new Customer
                  <v-icon large color="cyan darken-4"
                    >mdi-plus-circle-outline</v-icon
                  >
                </div>
              </template>
            </h1>
          </template>
          <span> Customer </span>
        </v-tooltip>
      </div>
    </template>
    <template v-slot:header-action>
      <div>
        <v-btn
          :disabled="formLoading"
          v-on:click="goBack()"
          class="custom-bold-button custom-grey-border"
          depressed
          >Cancel</v-btn
        >
        <v-btn
          depressed
          :disabled="!formValid || formLoading || pageLoading"
          :loading="formLoading"
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          v-on:click="validateJob()"
        >
          Save as Draft
        </v-btn>
        <v-btn
          depressed
          :disabled="!formValid || formLoading || pageLoading"
          :loading="formLoading"
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          v-on:click="validateJob(_, 'mark_as_approved')"
        >
          Save and Approve
        </v-btn>

        <!--   <v-btn
          class="custom-bold-button ml-4"
          depressed
          :disabled="!formValid || formLoading"
          :loading="formLoading"
          v-on:click="validateJob()"
          color="cyan white--text"
        >
          {{ contract_Id > 0 ? "Update" : "Save" }}
        </v-btn> -->
      </div>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow product-create-heigh"
        style="position: relative; height: calc(100vh - 250px);"
      >
        <div class="bg-white px-2">
          <v-form
            ref="createQuotationForm"
            v-model.trim="formValid"
            lazy-validation
            v-on:submit.stop.prevent="validateJob()"
          >
            <v-row>
              <v-col md="7">
                <label for="contract-title" class="required"
                  >Contract Title</label
                >
                <TextField
                  id="contract-title"
                  dense
                  filled
                  placeholder="Title"
                  solo
                  flat
                  counter="150"
                  v-model="dbContract.job_title"
                  color="cyan"
                  :maxlength="250"
                  :rules="[
                    validateRules.required(dbContract.job_title, 'Title'),
                  ]"
                />

                <TextAreaField
                  auto-grow
                  dense
                  filled
                  color="cyan"
                  v-model.trim="dbContract.description"
                  placeholder="Description"
                  solo
                  flat
                  row-height="25"
                  counter="250"
                />
                <v-row>
                  <v-col md="6">
                    <v-layout class="align-center">
                      <v-flex md3
                        ><label class="my-0">Billing Location</label></v-flex
                      >
                      <v-flex md9 class="position-relative">
                        <v-icon
                          v-on:click="openDialog('billing')"
                          small
                          class="py-0 my-0"
                          color="cyan"
                          style="position: absolute; top: -8px"
                          >mdi-pencil</v-icon
                        >
                      </v-flex>
                    </v-layout>
                    <template v-if="vBilling?.id">
                      <span v-if="vBilling && vBilling.property_address">
                        <!--  <v-icon small>mdi-map-marker</v-icon> --></span
                      >
                      <template>
                        <div
                          class="custom-flex-d"
                          v-if="vBilling.property_name"
                        >
                          <b>
                            <v-icon
                              style="
                                font-size: 18px;
                                margin-top: -3px !important;
                              "
                              color="#000"
                              class="cmt-2"
                            >
                              mdi-home-map-marker
                            </v-icon>
                          </b>
                          <span>{{ vBilling.property_name }}<br /></span>
                        </div>
                        <div v-else>
                          <em class="text-muted">
                            <v-icon
                              style="
                                font-size: 18px;
                                margin-top: -3px !important;
                              "
                              color="#000"
                              class="cmt-2"
                            >
                              mdi-home-map-marker
                            </v-icon>
                            no Site Name</em
                          >
                        </div>
                      </template>

                      <template>
                        <div class="custom-flex-d">
                          <b>
                            <v-icon
                              style="
                                font-size: 18px;
                                margin-top: -3px !important;
                              "
                              color="#000"
                              class="cmt-2"
                            >
                              mdi-map-marker
                            </v-icon>
                          </b>
                          <span>
                            <template v-if="vBilling.unit_no"
                              >{{ vBilling.unit_no }},</template
                            >
                            <template v-if="vBilling.street_1"
                              >{{ vBilling.street_1 }},</template
                            >
                            {{ vBilling.street_2 }}
                            <br />
                            {{ vBilling.country }}
                            <template
                              v-if="
                                vBilling.zip_code &&
                                vBilling.zip_code != '000000'
                              "
                            >
                              {{ vBilling.zip_code }}
                            </template>
                          </span>
                        </div>
                      </template>
                    </template>
                    <template v-else-if="vCustomer?.id">
                      <p class="mb-0 red--text">
                        Please select billing location
                      </p>
                    </template>
                    <template v-else>
                      <p class="mb-0 red--text">Please select customer</p>
                    </template>
                    <v-layout class="mt-3 align-center">
                      <v-flex md3
                        ><label class="my-0">Contact Details</label></v-flex
                      >
                      <v-flex md9 class="position-relative">
                        <v-icon
                          small
                          v-on:click="openDialog('billing-contact')"
                          class="py-0 my-0"
                          color="cyan"
                          style="position: absolute; top: -8px"
                          >mdi-pencil</v-icon
                        >
                      </v-flex>
                    </v-layout>
                    <template v-if="vBillingContact?.id">
                      <p class="mb-0">{{ vBillingContact.display_name }}</p>
                      <p class="mb-0">{{ vBillingContact.primary_phone }}</p>
                      <p class="mb-0">{{ vBillingContact.primary_email }}</p>
                    </template>
                    <template v-else-if="vCustomer?.id">
                      <p class="mb-0 red--text">Please select contact person</p>
                    </template>
                    <template v-else>
                      <p class="mb-0 red--text">Please select customer</p>
                    </template>
                  </v-col>
                  <v-col md="6">
                    <v-layout class="align-center">
                      <v-flex md3
                        ><label class="my-0">Site Location</label></v-flex
                      >
                      <v-flex md9 class="position-relative">
                        <v-icon
                          small
                          v-on:click="openDialog('property')"
                          class="py-0 my-0"
                          color="cyan"
                          style="position: absolute; top: -8px"
                          >mdi-pencil</v-icon
                        >
                      </v-flex>
                    </v-layout>

                    <template v-if="vProperty?.id">
                      <span v-if="vProperty && vProperty.property_address">
                        <!--   <v-icon small>mdi-map-marker</v-icon>--></span
                      >
                      <p
                        class="mr-2"
                        v-if="vProperty && vProperty.property_address"
                      >
                        <template>
                          <div
                            class="custom-flex-d"
                            v-if="vProperty?.property_name"
                          >
                            <b>
                              <v-icon
                                style="
                                  font-size: 18px;
                                  margin-top: -3px !important;
                                "
                                color="#000"
                                class="cmt-2"
                              >
                                mdi-home-map-marker
                              </v-icon>
                            </b>
                            <span>{{ vProperty?.property_name }}<br /></span>
                          </div>
                          <div v-else>
                            <em class="text-muted">
                              <v-icon
                                style="
                                  font-size: 18px;
                                  margin-top: -3px !important;
                                "
                                color="#000"
                                class="cmt-2"
                              >
                                mdi-home-map-marker
                              </v-icon>
                              no Site Name</em
                            >
                          </div>
                        </template>

                        <template>
                          <div class="custom-flex-d">
                            <b>
                              <v-icon
                                style="font-size: 18px; margin-top: -3px"
                                color="#000"
                                class="cmt-2"
                              >
                                mdi-map-marker
                              </v-icon>
                            </b>
                            <span>
                              <template v-if="vProperty?.unit_no"
                                >{{ vProperty?.unit_no }},</template
                              >
                              <template v-if="vProperty?.street_1"
                                >{{ vProperty?.street_1 }},</template
                              >
                              {{ vProperty?.street_2 }}
                              <br />
                              {{ vProperty?.country }}
                              <template
                                v-if="
                                  vProperty?.zip_code &&
                                  vProperty?.zip_code != '000000'
                                "
                              >
                                {{ vProperty?.zip_code }}
                              </template>
                            </span>
                          </div>
                        </template>
                      </p>
                    </template>
                    <template v-else-if="vCustomer?.id">
                      <p class="mb-0 red--text">Please select site location</p>
                    </template>
                    <template v-else>
                      <p class="mb-0 red--text">Please select customer</p>
                    </template>

                    <v-layout class="mt-3 align-center">
                      <v-flex md3
                        ><label class="my-0">Contact Details</label></v-flex
                      >
                      <v-flex md9 class="position-relative">
                        <v-icon
                          small
                          v-on:click="openDialog('property-contact')"
                          class="py-0 my-0"
                          color="cyan"
                          style="position: absolute; top: -8px"
                          >mdi-pencil</v-icon
                        >
                      </v-flex>
                    </v-layout>

                    <template v-if="vPropertyContact?.id">
                      <p class="mb-0">{{ vPropertyContact.display_name }}</p>
                      <p class="mb-0">{{ vPropertyContact.primary_phone }}</p>
                      <p class="mb-0">{{ vPropertyContact.primary_email }}</p>
                    </template>
                    <template v-else-if="vCustomer?.id">
                      <p class="mb-0 red--text">Please select contact person</p>
                    </template>
                    <template v-else>
                      <p class="mb-0 red--text">Please select customer</p>
                    </template>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="5">
                <table width="100%" style="table-layout: fixed">
                  <tr>
                    <td width="150" class="font-weight-600">
                      <label for="reference-no">Reference #</label>
                    </td>
                    <td>
                      <v-text-field
                        id="reference-no"
                        v-model.trim="dbContract.reference"
                        dense
                        filled
                        :disabled="pageLoading"
                        :loading="pageLoading"
                        color="cyan"
                        placeholder="Reference #"
                        :rules="[
                          validateRules.minLength(
                            dbContract.reference,
                            'Reference',
                            1
                          ),
                          validateRules.maxLength(
                            dbContract.reference,
                            'Reference',
                            100
                          ),
                        ]"
                        solo
                        flat
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td width="150" class="font-weight-600">
                      <label for="sales-representatives"
                        >Sales representatives</label
                      >
                    </td>
                    <td>
                      <v-autocomplete
                        dense
                        color="cyan"
                        filled
                        id="sales-representatives"
                        :items="userList"
                        :disabled="pageLoading"
                        :loading="pageLoading"
                        v-model.trim="dbContract.sales_executive"
                        placeholder="Sales representatives"
                        solo
                        flat
                        item-color="cyan"
                        item-text="full_name"
                        item-value="id"
                        hide-details
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                v-html="'No Sales Representative Found.'"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </td>
                  </tr>
                  <tr>
                    <td width="150" class="font-weight-600">
                      <label for="prepared-by">Prepared by</label>
                    </td>
                    <td>
                      <v-autocomplete
                        dense
                        color="cyan"
                        filled
                        id="prepared-by"
                        :items="userList"
                        :disabled="pageLoading"
                        :loading="pageLoading"
                        v-model.trim="dbContract.prepared_by_id"
                        placeholder="Prepared By"
                        solo
                        flat
                        item-color="cyan"
                        item-text="full_name"
                        item-value="id"
                        hide-details
                     
                      
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                v-html="'No Prepared by Found.'"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </td>
                  </tr>
                  <tr>
                    <td width="150" class="font-weight-600">
                      <label for="duration-value">Duration</label>
                    </td>
                    <td>
                      <v-layout>
                        <v-flex md6>
                          <v-text-field
                            dense
                            filled
                            id="duration-value"
                            color="cyan"
                            :disabled="pageLoading"
                            :loading="pageLoading"
                            v-mask="'###'"
                            v-model.trim="dbContract.duration_value"
                            placeholder="Duration"
                            solo
                            flat
                            hide-details
                            v-on:change="durationOnChnage"
                            v-on:keyup="durationOnChnage"
                            v-on:input="durationOnChnage"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md6>
                          <v-select
                            dense
                            color="cyan"
                            filled
                            id="duration-type"
                            :items="durationTypeList"
                            :disabled="pageLoading"
                            :loading="pageLoading"
                            v-model.trim="dbContract.duration_type"
                            v-on:change="durationOnChnage"
                            placeholder="Duration"
                            solo
                            flat
                            item-color="cyan"
                            hide-details
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title
                                    v-html="'No Duration Type Found.'"
                                  ></v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-select>
                        </v-flex>
                      </v-layout>
                    </td>
                  </tr>
                  <tr>
                    <td width="150" class="font-weight-600">
                      <label for="start-date-picker">Dates</label>
                    </td>
                    <td>
                      <v-layout>
                        <v-flex md6
                          ><DatePicker
                            solo
                            flat
                            :default-date="dbContract.contract_start"
                            v-model="dbContract.contract_start"
                            v-on:change="updateDuration($event)"
                          ></DatePicker
                        ></v-flex>

                        <v-flex md6>
                          <DatePicker
                            solo
                            flat
                            disabled
                            :default-date="dbContract.contract_end"
                            v-model="dbContract.contract_end"
                          ></DatePicker>
                        </v-flex>
                      </v-layout>
                    </td>
                  </tr>

                  <tr>
                    <td width="150" class="font-weight-600">
                      <label for="no-of-services" class="required"
                        >No. of Services</label
                      >
                    </td>
                    <td>
                      <v-text-field
                        dense
                        filled
                        id="no-of-services"
                        color="cyan"
                        :disabled="pageLoading"
                        :loading="pageLoading"
                        v-mask="'###'"
                        :rules="[
                          validateRules.required(
                            dbContract.total_service,
                            'No. of Services'
                          ),
                        ]"
                        v-model.trim="dbContract.total_service"
                        placeholder="No. of Services"
                        solo
                        flat
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                </table>
              </v-col>

              <v-col cols="12" ref="qtTermsConditions">
                <v-card flat class="custom-grey-border remove-border-radius">
                  <v-card-title
                    class="headline grey lighten-4"
                    @click="show_terms_condition = !show_terms_condition"
                  >
                    <h3
                      class="font-weight-700 custom-headline color-custom-blue"
                    >
                      <v-icon>{{
                        !show_terms_condition
                          ? "mdi-chevron-down"
                          : "mdi-chevron-up"
                      }}</v-icon>
                      TERMS &amp; CONDITIONS
                    </h3>
                  </v-card-title>
                  <v-expand-transition>
                    <v-card-text
                      class="p-6 font-size-16"
                      v-show="show_terms_condition"
                    >
                      <v-autocomplete
                        dense
                        color="cyan"
                        filled
                        label="Terms &amp; Conditions"
                        solo
                        flat
                        class="mb-2"
                        item-color="cyan"
                        item-text="label"
                        item-value="id"
                        hide-details
                        :disabled="formLoading"
                        :loading="formLoading"
                        :items="termsConditionList"
                        v-model="dbContract.term_condition_id"
                        v-on:change="update_term_condition()"
                      />
                      <tiny-mce
                        :disabled="formLoading"
                        v-model="dbContract.term_conditions"
                      />
                    </v-card-text>
                  </v-expand-transition>
                </v-card>
              </v-col>
              <v-col cols="12" ref="qtNote">
                <v-card flat class="custom-grey-border remove-border-radius">
                  <v-card-title
                    class="headline grey lighten-4"
                    @click="show_notes_attachment = !show_notes_attachment"
                  >
                    <h3
                      class="font-weight-700 custom-headline color-custom-blue"
                    >
                      <v-icon>{{
                        !show_notes_attachment
                          ? "mdi-chevron-down"
                          : "mdi-chevron-up"
                      }}</v-icon>
                      INTERNAL NOTES
                    </h3>
                  </v-card-title>
                  <v-expand-transition>
                    <v-card-text
                      class="p-6 font-size-16"
                      v-show="show_notes_attachment"
                    >
                      <v-layout>
                        <v-flex class="mr-4" md6>
                          <label class="font-size-16 font-weight-600"
                            >Internal Note</label
                          >
                          <tiny-mce
                            :disabled="formLoading"
                            v-model="dbContract.admin_note"
                          />
                        </v-flex>
                        <v-flex md6>
                          <label class="font-size-16 font-weight-600"
                            >Client Note
                          </label>
                          <tiny-mce
                            :disabled="formLoading"
                            v-model="dbContract.client_note"
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout class="mt-4">
                        <v-flex md12>
                          <DocumnetList
                            v-model="dbContract.attachments"
                            :document-type="2"
                          >
                          </DocumnetList>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-expand-transition>
                </v-card>
              </v-col>
            </v-row>
          </v-form>

          <customer-select
            :dialog="reCustomerDialog"
            @close="closeCustomerDialog"
          />
          <customer-create :key="`quotation-customer-create-${dialog_key}`" />
          <person-select
            :dialog="contactDialog"
            v-on:close="contactDialog = false"
            :type="contactType"
          />
          <address-select
            :dialog="propertyDialog"
            v-on:close="propertyDialog = false"
            :type="propertyType"
            :label="propertyLabel"
          />
          <entity-select :dialog="vEntityDialog" @close="closeEntityDialog" />
        </div>
      </perfect-scrollbar>
    </template>
  </CreateUpdateTemplate>
</template>

<script>
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ValidationMixin from "@/core/plugins/validation-mixin";
import TinyMCE from "@/view/pages/partials/TinyMCE.vue";
import moment from "moment-timezone";
import ObjectPath from "object-path";
import {
  SET_DIALOG_STATUS,
  SET_CREATE_DIALOG_STATUS,
  CLEAR_CUSTOMER,
} from "@/core/services/store/customer.module";
import {
  SET_CUSTOMER,
  SET_PROPERTY,
  SET_PROPERTY_CONTACT,
  SET_BILLING,
  SET_BILLING_CONTACT,
  RESET_CREATE_STATE,
} from "@/core/services/store/visit.module";
import {
  UPLOAD,
  QUERY,
  POST,
  PATCH,
} from "@/core/services/store/request.module";
import CustomerSelect from "@/view/components/CustomerSelect.vue";
import CustomerCreate from "@/view/components/CustomerCreateDialog.vue";
import PersonSelect from "@/view/components/PersonSelect.vue";
import AddressSelect from "@/view/components/AddressSelect.vue";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import KTCookie from "@/assets/js/components/cookie";
import DocumnetList from "@/view/pages/DocumnetList";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import EntityMixin from "@/core/plugins/entity-mixin";
import { SET_ENTITY } from "@/core/services/store/entity.module";
import DatePicker from "@/view/pages/partials/Datepicker.vue";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "create-quotation",
  mixins: [ValidationMixin, CommonMixin, EntityMixin],
  data() {
    return {
      pageLoading: false,
      dialog_key: Number(new Date()),
      formLoading: false,
      formValid: true,
      contractCreated: false,
      show_line_items: false,
      show_notes_attachment: false,
      show_terms_condition: false,
      related_type: 0,
      tag_type: null,
      contractDialog: false,
      contract_Id: 0,
      dbContract: {
        job_title: null,
        description: null,
        property_person_notify: 1,
        billing_person_notify: 1,
        rating: 1,
        reference: null,
        duration_value: 1,
        duration_type: "year",
        contract_start: moment().format("YYYY-MM-DD"),
        contract_end: moment().add(1, "year").format("YYYY-MM-DD"),
        sales_executive: null,
        prepared_by: null,
        prepared_by_id: null,
        is_contract: true,
        duration: null,
        total_service: null,
        remark: null,
        discount_value: null,
        discount_value_type: null,
        tax_applied: null,
        adjustment: null,
        sales: null,
        term_condition_id: 0,
        term_conditions: null,
        /*   admin_note_id: 0, */
        admin_note: null,
        /*  client_note_id: 0, */
        client_note: null,
        attachments: [
          {
            file: null,
            name: null,
            remark: null,
            suffix: null,
            tags: null,
            search: null,
            start_date: null,
            end_date: null,
            reminder_date: null,
          },
        ],
      },
      durationTypeList: [
        { text: "Days", value: "days" },
        { text: "Month", value: "month" },
        { text: "Year", value: "year" },
      ],
      attachments: [
        {
          accepted_file: null,
          file_name: null,
          file_type: null,
        },
      ],

      defaultNotes: [],
      unit: [],
      FullProgressPaymentList: [],

      clientNoteList: [],
      termsConditionList: [],
      userList: [],
      dbLineItems: [],
      dbEquipments: [],
      todayDate: null,
      updatedContractData: {},
      propertyType: null,
      propertyLabel: null,
      propertyDialog: false,
      contactType: null,
      contactDialog: false,
      contract_status: false,
    };
  },
    watch: {
    "dbContract.duration_value"() {
      this.updateDuration(this.dbContract.contract_start);
    },
    "dbContract.duration_type"() {
      this.updateDuration(this.dbContract.contract_start);
    },
    "dbContract.contract_start"(newVal) {
      this.updateDuration(newVal);
    },
    reEntityId: {
      immediate: true,
      handler(param) {
        if (param) {
          if (param > 0) {
            this.get_attributes();
          }
        }
      },
    },
  },
  components: {
    "customer-select": CustomerSelect,
    "customer-create": CustomerCreate,
    "person-select": PersonSelect,
    "address-select": AddressSelect,
    "tiny-mce": TinyMCE,
    TextAreaField,
    CreateUpdateTemplate,
    DocumnetList,
    DatePicker,
  },
  methods: {
    durationOnChnage() {
      if (
        this.dbContract.duration_value &&
        Number(this.dbContract.duration_value) < 1
      ) {
        this.dbContract.duration_value = 1;
      }
      this.updateDuration(this.dbContract.contract_start);
    },

    updateDuration(contract_start) {
      if (contract_start) {
        this.dbContract.contract_start = contract_start;
      }
      const { duration_value, duration_type, contract_start: cStart } =
        this.dbContract;

      if (cStart && duration_value && duration_type) {
        let output = moment(cStart).add(duration_value, duration_type);
        this.dbContract.contract_end = moment(output)
          .subtract(1, "day")
          .format("YYYY-MM-DD");
      }
    },

    createCustomerDialog() {
      if (!this.reEntityId) {
        ErrorEventBus.$emit("update:error", "Select Entity");
        return false;
      }
      this.dialog_key = Number(new Date());
      this.$nextTick(() => {
        this.$store.commit(SET_CREATE_DIALOG_STATUS, true);
      });
    },

    update_term_condition() {
      let output = this.lodash.find(this.termsConditionList, {
        id: this.lodash.toSafeInteger(this.dbContract.term_condition_id),
      });
      if (output) {
        this.dbContract.term_conditions = output.description;
      }
    },
    update_admin_note() {
      let output = this.lodash.find(this.adminNoteList, {
        id: this.dbContract.admin_note_id,
      });
      if (output) {
        this.dbContract.admin_note = output.description;
      }
    },
    update_client_note() {
      let output = this.lodash.find(this.clientNoteList, {
        id: this.dbContract.client_note_id,
      });
      if (output) {
        this.dbContract.client_note = output.description;
      }
    },
    uploadFiles() {
      let _this = this;
      return new Promise((resolve, reject) => {
        let formData = new FormData();

        let status = false;

        for (let i = 0; i < _this.attachments.length; i++) {
          if (_this.attachments[i].accepted_file) {
            status = true;
            formData.append(
              `files[${i}]`,
              _this.attachments[i].accepted_file,
              _this.attachments[i].file_name
            );
          }
        }

        if (!status) {
          resolve([]);
        } else {
          _this.$store
            .dispatch(UPLOAD, { url: "file-manager/upload", data: formData })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    closeCustomerDialog() {
      this.$store.commit(SET_DIALOG_STATUS, false);
    },
    openDialog(type) {
      if (!this.reEntityId) {
        ErrorEventBus.$emit("update:error", "Select Entity");
        return false;
      }

      this.$store.commit(SET_DIALOG_STATUS, false);
      this.propertyType = null;
      this.propertyLabel = null;
      this.propertyDialog = false;
      this.contactType = null;
      this.contactDialog = false;

      if (type == "customer") {
        this.$store.commit(SET_DIALOG_STATUS, true);
      } else {
        if (!this.vCustomerId) {
          ErrorEventBus.$emit("update:error", "Please Select Customer.");
          return false;
        }
        if (type == "billing") {
          this.propertyType = "billing";
          this.propertyLabel = "Billing Location";
          this.propertyDialog = true;
        }
        if (type == "billing-contact") {
          this.contactType = "billing";
          this.contactDialog = true;
        }
        if (type == "property") {
          this.propertyType = "property";
          this.propertyLabel = "Service Location";
          this.propertyDialog = true;
        }
        if (type == "property-contact") {
          this.contactType = "property";
          this.contactDialog = true;
        }
      }
    },
    validateJob(type, action) {
      if (!this.reEntityId) {
        ErrorEventBus.$emit("update:error", "Select Entity");
        return false;
      }

      if (!this.vCustomerId) {
        ErrorEventBus.$emit("update:error", "Select Customer");
        return false;
      }

      if (!this.vPropertyId) {
        ErrorEventBus.$emit("update:error", "Select Service Location");
        return false;
      }

      if (!this.vPropertyContactId) {
        ErrorEventBus.$emit("update:error", "Select Service Contact Person");
        return false;
      }

      if (!this.vBillingId) {
        ErrorEventBus.$emit("update:error", "Select Billing Location");
        return false;
      }

      if (!this.vBillingContactId) {
        ErrorEventBus.$emit("update:error", "Select Billing Contact Person");
        return false;
      }

      const validateStatus = this.$refs.createQuotationForm.validate();

      const formErrors = this.validateForm(this.$refs.createQuotationForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }

      if (validateStatus) {
        this.onSubmit(type, action);
      }
    },
    async onSubmit(type, statusapprove) {
      const new_attachments = await this.uploadFiles();

      const request = {
        ...this.dbContract,
        attachments: [...this.dbContract.attachments, ...new_attachments],
        customer: this.vCustomerId,
        property: this.vPropertyId,
        billing: this.vBillingId,
        entity_id: this.reEntityId,
        property_contact_person: this.vPropertyContactId,
        billing_contact_person: this.vBillingContactId,
        action: typeof type == "string" ? type : undefined,
        statusapprove: statusapprove ? statusapprove : null,
      };

      let requestType = POST;
      let requestURL = "contract-v1";

      let contractId = this.$route?.query?.edit ?? 0;

      if (contractId) {
        requestType = PATCH;
        requestURL = `contract-v1/${contractId}`;
      }

      this.formLoading = true;

      this.$store
        .dispatch(requestType, { url: requestURL, data: request })
        .then(({ data }) => {
          this.contractCreated = true;
          this.$store.dispatch(CLEAR_CUSTOMER);
          this.$nextTick(() => {
            this.$router.push(
              this.getDefaultRoute("contract.detail", {
                params: { id: data.id },
              })
            );
          });
        })
        .catch(() => {
          this.formLoading = false;
        });
    },
    get_attributes() {
      this.$store
        .dispatch(QUERY, {
          url: "contract/options",
          data: {
            contract: ObjectPath.get(this.$route, "query.edit"),
            duplicate: ObjectPath.get(this.$route, "query.duplicate"),
            entity_id: this.reEntityId ?? 0,
          },
        })
        .then((response) => {
          this.unit = ObjectPath.get(response, "data.uom_list", []);
          // adding the code for terms and conditions
          this.dbContract.barcode = ObjectPath.get(response, "data.barcode");

          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Contract", route: "contract" },
            { title: "Create" },
            { title: this.dbContract.barcode },
          ]);

          this.termsConditionList = ObjectPath.get(
            response,
            "data.term_condition_list",
            []
          );

          let defaultTermConditionObject = this.lodash.find(
            this.termsConditionList,
            {
              primary: 1,
            }
          );
          if (defaultTermConditionObject) {
            this.dbContract.term_condition_id = defaultTermConditionObject.id;
            this.dbContract.term_conditions =
              defaultTermConditionObject.description;
          }

          this.userList = ObjectPath.get(response, "data.sales_users", []);

          this.dbContract.sale_by = ObjectPath.get(response, "data.user_id", 0);
          this.dbContract.prepared_by_id = ObjectPath.get(
            response,
            "data.user_id",
            0
          );

          let dbContract = ObjectPath.get(response, "data.contract");
          let duplicateQuotation = ObjectPath.get(response, "data.duplicate");
          if (dbContract?.id) {

            this.$store.commit(SET_ENTITY, dbContract.entity_relation);

            this.dbContract.barcode = dbContract?.barcode;
            this.updatedContractData = ObjectPath.get(
              response,
              "data.contract"
            );
            this.dbContract.job_title = dbContract?.job_title;
            this.dbContract.description = dbContract?.description;
            this.dbContract.your_reference = dbContract?.your_reference;
            this.dbContract.reference = dbContract?.reference;
            this.dbContract.prepared_by_id = dbContract?.prepared_by_id;
            this.dbContract.sales_executive = dbContract?.sales_executive;
            this.dbContract.open_till = dbContract?.open_till;
            this.dbContract.validity_till = dbContract?.validity_till;
            this.dbContract.type = dbContract?.type;
            this.dbContract.tags = dbContract?.tags;

          

            this.dbContract.total_service = this.lodash.toSafeInteger(
              dbContract?.total_service
            );
            this.dbContract.duration_value = this.lodash.toSafeInteger(
              dbContract?.duration_value
            );
            this.dbContract.duration_type = dbContract?.duration_type;
            this.dbContract.contract_start = dbContract?.contract_start;
            this.dbContract.contract_end = dbContract?.contract_end;
            this.dbContract.base_type = dbContract?.base_type;

            this.dbContract.date = moment(dbContract?.date).format(
              "YYYY-MM-DD"
            );
            this.dbContract.rating = dbContract?.rating;
            /* this.dbContract.attachments = dbContract?.attachments ?? []; */

            this.dbContract.notify_billing_contact_person =
              dbContract?.notify_billing_contact_person;
            this.dbContract.notify_property_contact_person =
              dbContract?.notify_property_contact_person;

            this.dbContract.client_note_id = dbContract?.client_note_id;
            this.dbContract.client_note = dbContract?.admin_remark;

            this.dbContract.term_condition_id = dbContract?.term_condition_id;
            this.dbContract.term_conditions = dbContract?.term_conditions;

            this.dbContract.admin_note_id = dbContract?.admin_note_id;
            this.dbContract.admin_note = dbContract?.admin_remark;

            this.$store.commit(SET_ENTITY, dbContract.entity_relation);

            this.$store.commit(SET_CUSTOMER, dbContract?.customer_relation);
            this.$store.commit(SET_PROPERTY, dbContract?.property_relation);
            this.$store.commit(
              SET_PROPERTY_CONTACT,
              dbContract?.property_contact_person_relation
            );
            this.$store.commit(SET_BILLING, dbContract?.billing_relation);
            this.$store.commit(
              SET_BILLING_CONTACT,
              dbContract?.billing_contact_person_relation
            );

            this.$store.dispatch(SET_BREADCRUMB, [
              { title: "Contract", route: "contract" },
              { title: "Update" },
              { title: this.dbContract.barcode },
            ]);
          } else if (duplicateQuotation?.id) {
            this.dbContract.q_duplicate_barcode = duplicateQuotation.barcode;
            this.dbContract.quotation_duplicate = duplicateQuotation.id;
            this.updatedContractData = ObjectPath.get(
              response,
              "data.duplicate"
            );
            this.dbContract.title = duplicateQuotation.title;
            this.dbContract.description = duplicateQuotation.description;
            this.dbContract.your_reference = duplicateQuotation.your_reference;
            this.dbContract.reference = duplicateQuotation.reference;
            this.dbContract.prepared_by_id = duplicateQuotation.prepared_by_id;
            this.dbContract.sales_executive =
              duplicateQuotation.sales_executive;
            this.dbContract.open_till = duplicateQuotation.open_till;
            this.dbContract.validity_till = duplicateQuotation.validity_till;
            this.dbContract.type = duplicateQuotation.type;
            this.dbContract.tags = duplicateQuotation.tags;
            this.dbContract.date = moment(duplicateQuotation.date).format(
              "YYYY-MM-DD"
            );
            this.dbContract.rating = duplicateQuotation.rating;
            this.dbContract.attachments = [];

            this.dbContract.notify_billing_contact_person =
              duplicateQuotation.notify_billing_contact_person;
            this.dbContract.notify_property_contact_person =
              duplicateQuotation.notify_property_contact_person;

            this.dbContract.client_note_id = duplicateQuotation.client_note_id;
            this.dbContract.client_note = duplicateQuotation.client_remark;

            this.dbContract.term_condition_id =
              duplicateQuotation.term_condition_id;
            this.dbContract.term_conditions =
              duplicateQuotation.term_conditions;

            this.dbContract.admin_note_id = duplicateQuotation.adminte_id;
            this.dbContract.admin_note = duplicateQuotation.admin_remark;
            this.$store.dispatch(SET_BREADCRUMB, [
              { title: "Duplicate", route: "quotation" },
              { title: "Duplicate" },
              { title: this.dbContract.barcode },
            ]);
          }
        })
        .catch((error) => {
          this.logError(error);
          this.goBack();
        })
        .finally(() => {
          // this.formLoading = false;
        });
    },
    getCustomer(customerId, contactPersonId, propertyId) {
      this.$store
        .dispatch(QUERY, {
          url: `customer-with-relation/${customerId}`,
          data: {
            contact_person: contactPersonId,
            property: propertyId,
          },
        })
        .then((response) => {
          this.$store.commit(
            SET_CUSTOMER,
            ObjectPath.get(response, "data.customer", {})
          );
          this.$store.commit(
            SET_PROPERTY,
            ObjectPath.get(response, "data.property", {})
          );
          this.$store.commit(
            SET_PROPERTY_CONTACT,
            ObjectPath.get(response, "data.property_contact_person", {})
          );
          this.$store.commit(
            SET_BILLING,
            ObjectPath.get(response, "data.billing", {})
          );
          this.$store.commit(
            SET_BILLING_CONTACT,
            ObjectPath.get(response, "data.billing_contact_person", {})
          );
        })
        .catch(() => {
          this.goBack();
        })
        .finally(() => {
          //
        });
    },
  },
  mounted() {
    this.$refs.createQuotationForm.validate();
    this.get_attributes();
    this.contract_Id = Number(this.$route?.query?.edit ?? 0);

    this.$store.dispatch(SET_BREADCRUMB, []);
  },
  destroyed() {
    this.$store.dispatch(CLEAR_CUSTOMER);
    this.$store.dispatch(RESET_CREATE_STATE);
    /*  this.$store.dispatch(CLEAR_LINE_ITEM); */
  },
  beforeDestroy() {
    KTCookie.setCookie("kt_aside_toggle_state", "off");
    localStorage.setItem("kt_aside_toggle_state", "off");
  },
  created() {
    this.todayDate = moment().format("YYYY-MM-DD");
    this.dbContract.date = this.todayDate;
    this.dbContract.invoice_date = this.todayDate;
    this.dbContract.enquiry = this.lodash.toSafeInteger(
      ObjectPath.get(this.$route, "query.enquiry")
    );
  },
  beforeCreate() {
    KTCookie.setCookie("kt_aside_toggle_state", "on");
    localStorage.setItem("kt_aside_toggle_state", "on");
    this.$store.dispatch(CLEAR_CUSTOMER);
    this.$store.dispatch(RESET_CREATE_STATE);
    /*  this.$store.dispatch(CLEAR_LINE_ITEM); */
  },
  computed: {
    ...mapGetters([
      "vCustomer",
      "vProperty",
      "vPropertyContact",
      "vBilling",
      "vBillingContact",
      "vCustomerId",
      "vPropertyId",
      "vPropertyContactId",
      "vBillingId",
      "vBillingContactId",
      "reCustomerDialog",
      "vSelectedLineItem",
      "vCalculations",
    ]),
  },
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.contractCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.quotation-create-page {
  border-top: solid 8px #f7941e;

  label {
    padding-left: 5px;
    font-weight: 600;
  }

  p {
    padding-left: 5px;
  }
}

.form-action {
  display: flex;
  justify-content: space-between;

  .form-title {
    font-size: 24px;
    font-family: "Poppins", Helvetica, Arial, sans-serif;
    font-weight: 700;
    color: #24326d;
    letter-spacing: 1.5px;
    line-height: 1.11em;

    .form-title-link {
      color: #4d6974;
      border-bottom: dashed 2px #4d6974;
    }
  }
}
</style>
